<template>
  <div>
    <QS-scroller-box v-loading="loading">
      <QS-h3-title title="门店详情" />
      <QS-h4-title title="基本信息" />
      <!-- eslint-disable-next-line vue/no-unused-refs -->
      <form-text-box ref="storeInfoBox"
        :dataList="storeInfo_formConfig"
        :model="storeInfo_model"
        :column="2"
      />
      <QS-h4-title title="上架的租赁方案" />
      <QS-common-table
        :data="list"
        :columns="columns"
        :pagination="false"
      />
    </QS-scroller-box>
  </div>
</template>
<script>
import detailDataConfig from '../config/detail'
// eslint-disable-next-line import/no-cycle
import addDataConfig from '../config/add'
import { storeDetail } from '@/api/domain/shop'

export default {
  name: 'detailStore',
  data() {
    const { storeInfo_formConfig, storeInfo_model } = detailDataConfig.call(this)
    const { columns } = addDataConfig.call(this)
    return {
      storeInfo_formConfig,
      storeInfo_model,
      columns,
      list: [],
      storeVO: {},
      loading: false,
    }
  },
  created() {
    const { id } = this.$route.query
    id && this.queryDetailData(id)
  },
  methods: {
    // 获取详情数据
    async queryDetailData(id) {
      this.loading = true
      const { code, data } = await storeDetail({ id })
      this.loading = false
      if (code === 1) {
        // 租赁方案
        this.list = data.rentPlans || []
        // eslint-disable-next-line no-multi-assign
        const storeVO = this.storeVO = data.storeVO || {}
        const needLicenseType = data.needLicenseType || [10, 20, 30]
        const { address, name, contactTel, provinceName, cityName, contactQRCode } = storeVO
        // 基本信息反显
        this.storeInfo_model.name = name || ''
        this.storeInfo_model.contactTel = contactTel || ''
        this.storeInfo_model.provinceName = provinceName || ''
        this.storeInfo_model.cityName = cityName || ''
        this.storeInfo_model.needLicenseType = needLicenseType
        this.storeInfo_model.contactQRCode = this.getURL({ data: contactQRCode })
        const qrImg = this.storeInfo_formConfig.find((item) => item.itemConfig.prop === 'contactQRCode')
        qrImg.elConfig.imgSrc = this.storeInfo_model.contactQRCode

        // 设置地址
        this.storeInfo_model.address = address || ''
      }
    },
  },
}
</script>
